// The standard texts for the add-on service message fields (SEC-330).
//
// Each of these fields holds the message that is sent when that alarm type
// triggers — on screen (vibration), by SMS, or to a display. They used to start
// empty, and the standard text was only reachable by pressing the "Standard"
// button, so a field was sometimes left blank. A blank message is worse than a
// generic one when an alarm goes off.
//
// The angle-bracket parts are placeholders the alarm pipeline fills in when the
// alarm is sent: <LarmNamn> is the device name, <RF-Tagg> the tag it was
// triggered from, and <SecurCloud> the position link. They are the same in
// every language — they are tokens, not words shown to a user — so these texts
// are deliberately not translated.
//
// This is the single source of truth for the frontend. Both places that edit
// these fields read from here:
//   - views/admin/create/alarm.vue      (a new device starts from these)
//   - components/modal/alarm_info.vue   (the "Standard" button restores them)
//
// The server keeps the same list in utils/automatic-device-creation.js, for
// devices created automatically from an order. Change both together.

export const STANDARD_MESSAGE_TEMPLATES = {
  // On-screen / vibration messages (max 130 characters)
  vibration_pushb_template: "Skarpt <LarmNamn> <RF-Tagg>",
  vibration_mandown_template: "Man-Down <LarmNamn> <RF-Tagg>",
  vibration_callb_template: "Internt <LarmNamn> <RF-Tagg>",
  vibration_callb2_template: "Internt <LarmNamn> <RF-Tagg>",
  vibration_timer_alarm_template: "Timer Alarm <LarmNamn>",

  // SMS messages (max 160 characters)
  sms_pushb_template: "Skarpt <LarmNamn> <RF-Tagg> <SecurCloud>",
  sms_mandown_template: "Man-Down <LarmNamn> <RF-Tagg> <SecurCloud>",
  sms_callb_template: "Internt <LarmNamn> <RF-Tagg> <SecurCloud>",
  sms_callb2_template: "Internt <LarmNamn> <RF-Tagg> <SecurCloud>",
  sms_five_push_template: "Test <LarmNamn> <RF-Tagg> <SecurCloud>",
  sms_timer_alarm_template: "Timer Alarm <LarmNamn> <RF-Tagg> <SecurCloud>",

  // Display messages (max 160 characters)
  display_pushb_template: "Skarpt <LarmNamn> <RF-Tagg>",
  display_mandown_template: "Man-Down <LarmNamn> <RF-Tagg>",
  display_callb_template: "Internt <LarmNamn> <RF-Tagg>",
  display_callb2_template: "Internt <LarmNamn> <RF-Tagg>",
  display_timer_template: "Timer Alarm <LarmNamn> <RF-Tagg>",
};

export default STANDARD_MESSAGE_TEMPLATES;
